import React, { cloneElement } from 'react';
import {
    List, Filter, Datagrid, TextInput, TextField, ReferenceField, useListContext, SelectInput, ReferenceInput,
    TopToolbar, ExportButton, sanitizeListRestProps, DeleteButton, CreateButton, usePermissions, useRefresh, AutocompleteInput
} from 'react-admin';
import ISConfig from '../config';

const ActionButtons = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props;
    const {
        resource,
        displayedFilters,
        filterValues,
        basePath,
        showFilter,
        record,
    } = useListContext();

    return (
        <TopToolbar className="mb-3" {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            <CreateButton basePath={basePath} record={record} />
            <ExportButton />
        </TopToolbar>
    );
}

const LocationFilter = (props) => {
    var LocationStatusSelectChoices = [];
    if (ISConfig.statuses != undefined || ISConfig.statuses != null) { ISConfig.statuses.location.forEach(element => { LocationStatusSelectChoices.push({ id: element, name: element }) }); }

    return (
        <Filter {...props}>
            <TextInput className="pt-1" label={<h6 className="px-2 small rounded" style={{ backgroundColor: 'rgb(250, 250, 250)' }}>Name</h6>} source="name" fullWidth variant="outlined" alwaysOn />
            <SelectInput className="pt-1" label={<h6 className="px-2 small rounded" style={{ backgroundColor: 'rgb(250, 250, 250)' }}>Status</h6>} source="status" choices={LocationStatusSelectChoices} fullWidth variant="outlined" />
            <ReferenceInput source="customer_id" label={<h6 className="px-2 small rounded" style={{ backgroundColor: 'rgb(250, 250, 250)' }}>Customer</h6>} resource="customers" reference="customers" filterToQuery={searchText => ({ name: searchText })} fullWidth variant="outlined">
                <AutocompleteInput optionText="name" fullWidth variant="outlined" />
            </ReferenceInput>
        </Filter>
    )
};

const LocationList = props => {
    const toRedirect = useRefresh();
    const p = usePermissions();
    const isAdmin = p.loaded && p.permissions && 'user' in p.permissions && 'admin' in p.permissions && p.permissions.admin;
    const LocationDeleteButton = isAdmin ? (<DeleteButton redirect={toRedirect} />) : '';

    return (
        <>
            <h3 className="text-danger px-3 px-md-0 pt-3 pt-md-0" style={{ fontFamily: 'Arial, sans-serif' }}>Locations</h3>
            <List {...props} title=" " filters={<LocationFilter />} actions={<ActionButtons />} bulkActionButtons={false}>
                <Datagrid rowClick="show" className="table table-sm table-hover table-borderless">
                    <TextField source="name" className="px-3 text-capitalize" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Name</h6>} />
                    <ReferenceField label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Customer </h6>} source="customer_id" resource="customers" reference="customers" link="show" sortBy="customer.name">
                        <TextField className="px-3" source="name" />
                    </ReferenceField>
                    <TextField source="status" className="px-3 text-capitalize" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Status </h6>} />
                    <TextField source="address.street" className="px-3 text-capitalize" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Street </h6>} />
                    <TextField source="address.zip" className="px-3 text-capitalize" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>ZIP </h6>} />
                    <TextField source="address.city" className="px-3 text-capitalize" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>City </h6>} />
                    <TextField source="address.state" className="px-3 text-capitalize" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>State </h6>} />
                    <ReferenceField label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Phone </h6>} source="contact_id" resource="contacts" reference="contacts" link="show" >
                        <TextField className="px-3" source="phone" />
                    </ReferenceField>
                    {LocationDeleteButton}
                </Datagrid>
            </List>
        </>
    )
};

export default LocationList;
